import React from 'react';
import { message } from 'antd';
import { isEmpty } from 'lodash';
import get from 'lodash/get';
import { observer } from 'mobx-react';
import moment from 'moment';
import { getAcceptedPartnerProposal, getListProjectActionAdmin, getPartnerProposal, getProjectDetail, getProjectReports } from '@gtintel/platform-api';
import { LoadingSpinner2 } from '@gtintel/platform-atoms';
import { MATCHED_ID, PROJECT_ACTIVATED_ID } from '@gtintel/platform-constants';
import { FeaturesContext } from '@gtintel/platform-context';
import { PartnerModal } from '@gtintel/platform-molecules';
import { BatchType } from '@gtintel/platform-types';
import RightPane from './RightPane';
import { confirm, createProjectFlags, searchPartner, selectPartner, sendNotification, unMatchPartner, updateSearchPartnerInput } from './utils';
import { getPartnerData } from './utils/others';
import { changeProjectStatus, changeProjectStatusToActivated } from './utils/pages_project';
class _LegacyProjectDetailPartners extends React.Component {
  constructor(props) {
    super(props);
    this.changeStatus = void 0;
    this.changeStatusToActivated = void 0;
    this.confirm = void 0;
    this.scrollHorizontal = void 0;
    this.scrollToRight = void 0;
    this.searchPartner = void 0;
    this.selectPartner = void 0;
    this.sendMessengerTo = void 0;
    this.sendNotification = void 0;
    this.tagsRef = void 0;
    this.unMatchPartner = void 0;
    this.updateSearchPartnerInput = void 0;
    this.createProjectFlags = void 0;
    this.disabledDate = value => value < moment();
    this.tagsRef = React.createRef();
    this.state = {
      activeTab: '1',
      allowSubmitToClient: false,
      chatPopup: null,
      end_date: '',
      getPartner: [],
      isActivated: false,
      isPartnerModalOpen: false,
      listChatConnecting: [],
      loading: true,
      loadingPartner: true,
      modalPreviewPDF: false,
      partnerProposal: {},
      projectReports: null,
      projects: null,
      searchPartner: '',
      selectPartner: [],
      selectPartnerName: '',
      statusDetail: '',
      subprojects: [],
      typeBatch: null
    };

    //partner methods
    this.searchPartner = searchPartner.bind(this);
    this.updateSearchPartnerInput = updateSearchPartnerInput.bind(this);
    this.selectPartner = selectPartner.bind(this);

    //project methods
    this.confirm = confirm.bind(this);
    this.sendNotification = sendNotification.bind(this);
    this.unMatchPartner = unMatchPartner.bind(this);
    this.createProjectFlags = createProjectFlags.bind(this);

    //other methods
    this.changeStatus = changeProjectStatus.bind(this);
    this.changeStatusToActivated = changeProjectStatusToActivated.bind(this);
  }
  static async getInitialProps({
    query
  }) {
    return {
      query
    };
  }
  componentDidMount() {
    this.fetchProjectData();
  }
  componentDidUpdate(prevProps) {
    if (this.props.query.id !== prevProps.query.id) {
      this.setState({
        loading: true
      }, () => {
        this.fetchProjectData();
      });
    }
  }
  async fetchProjectData() {
    const {
      adminProjectDetailStore
    } = this.props;
    try {
      // Make sure we don't hide the loading spinner false until all these
      // calls are finished, or the UI looks janky
      await Promise.all([getProjectDetail(this.props.query.id).then(res => {
        const projects = {
          ...res,
          statusDetail: res.status,
          typeBatch: res.source
        };
        this.setState({
          projects
        });
      }).catch(() => message.error('Could not load project.')), getListProjectActionAdmin({
        parent_id: this.props.query.id
      }).then(({
        results
      }) => {
        this.setState({
          subprojects: results
        });
      }).catch(() => {}), adminProjectDetailStore.fetchProjectDetail(Number(this.props.query.id)).then(() => {
        const {
          projectDetail
        } = adminProjectDetailStore;
        if (projectDetail) {
          adminProjectDetailStore.setBatchType(projectDetail.source || BatchType.STANDARD);
          adminProjectDetailStore.fetchProjectReports(projectDetail.id);
          const isActivated = (+get(projectDetail, 'status') || 0) >= +PROJECT_ACTIVATED_ID;
          this.setState({
            isActivated
          });
        }
        if (+get(projectDetail, 'status', 0) >= +MATCHED_ID) {
          this.setState({
            allowSubmitToClient: true
          });
        }
      })]);
      getAcceptedPartnerProposal(this.props.query.id).then(partnerProposal => {
        this.setState({
          partnerProposal
        });
      }).catch(() => message.error('Could not load partner proposals.'));
      adminProjectDetailStore.fetchProjectType();
      adminProjectDetailStore.fetchCategoryTag();
      getProjectReports(Number(this.props.query.id)).then(projectReports => this.setState({
        projectReports: {
          ...projectReports
        }
      }));
      this.getPartnerProposal();
    } catch {
      message.error('An unknown error occurred.');
    } finally {
      this.setState({
        loading: false
      });
    }
  }
  async getPartnerProposal() {
    this.setState({
      loadingPartner: true
    });
    try {
      const partners = await getPartnerProposal(Number(this.props.query.id), this.state.searchPartner);
      this.setState({
        getPartner: partners
      });
    } catch (e) {
      message.error('Error: could not load partner(s)');
      console.error(e);
    } finally {
      this.setState({
        loadingPartner: false
      });
    }
  }
  render() {
    const {
      getPartner,
      projects
    } = this.state;
    const {
      adminProjectDetailStore
    } = this.props;
    const {
      batchType,
      projectDetail
    } = adminProjectDetailStore;

    // @ts-ignore
    const partnerData = getPartnerData(getPartner, batchType, projectDetail);
    return <>
        {this.state.loading || isEmpty(projects) ? <LoadingSpinner2 margin="150px" /> : <RightPane handleSearchPartner={this.searchPartner} updateSearchPartnerInput={this.updateSearchPartnerInput} handleSelectPartner={this.selectPartner} isActivated={this.state.isActivated} loadingPartner={this.state.loadingPartner} openPartnerModal={() => this.setState({
        isPartnerModalOpen: true
      })}
      /* @ts-ignore */ partnerData={partnerData} project={this.state.projects} projectDetail={projectDetail} searchPartner={this.state.searchPartner}
      /* @ts-ignore */ selectingPartner={this.state.selectingPartner} unMatchPartner={this.unMatchPartner} />}
        <PartnerModal isOpen={this.state.isPartnerModalOpen} onCancel={() => this.setState({
        isPartnerModalOpen: false
      })} partner={this.props.partnerStore.selectedPartner} />
      </>;
  }
}
_LegacyProjectDetailPartners.contextType = FeaturesContext;
export const LegacyProjectDetailPartners = observer(_LegacyProjectDetailPartners);